import { reducer } from 'redux-form/immutable';

export default reducer;



// WEBPACK FOOTER //
// ./app/reducers/form.js